import React from "react";
import { Button, Box, Typography } from "@mui/material";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleIcon from "../../common/svg/GoogleIcon";
import { googleLogin } from "../api/actions/query";

const GoogleLoginButton = ({ dispatch }) => {
  const googleLoginHandler = useGoogleLogin({
    scope: "openid profile email https://www.googleapis.com/auth/user.phonenumbers.read",
    onSuccess: async (tokenResponse) => {
        const accessToken = tokenResponse.access_token;
        await googleLogin(accessToken, dispatch);
    },
    onError: (error) => {
      console.error("Google login failed:", error);
    },
  });

  return (
    <Button
      onClick={() => googleLoginHandler()}
      fullWidth
      sx={{
        color: "#3C4043",
        borderRadius: "30px",
        py: 1.2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "none",
        border: "1px solid #D9D9D9",
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <GoogleIcon />
        <Typography sx={{ ml: 1, fontSize: "15px" }}>
          Login with Google
        </Typography>
      </Box>
    </Button>
  );
};

export default GoogleLoginButton;
